import { Outlet } from 'react-router-dom';

import { Footer } from '@/components/Footer';

export const Main = () => {
  return (
    <div>
      <Outlet />
      <Footer />
    </div>
  );
};
